module.exports = __webpack_public_path__ + "static/media/2012 Istanbul, Turkey.ae6510fb.jpg";